import axiosInstance from "../lib/axiosInstance";

const Faqmodel = class {
  constructor() {
    this.baseUrl = "/adminapi/faq/";
  }

  async list(data = []) {
    return (
      await axiosInstance.get(`${this.baseUrl}`)
    ).data;
  }

  async listbyfaqsid(data = []) {
    return (
      await axiosInstance.get(`${this.baseUrl}`,{params:data})
    );
  }
  async removeFaq(data = {}) {
    return await axiosInstance.delete(`${this.baseUrl}?id=${data}`);
  }

  async create(data = []) {
    return await axiosInstance.post(this.baseUrl, data);
  }

  async editFaqs(data = []) {
    return await axiosInstance.put(this.baseUrl, data);
  }
 
};

export default new Faqmodel();
